import { FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass } from 'react-icons/fa';


// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {


    /*----- Page Sidebar -----*/
    case 'date':
      return <FaCalendarAlt />; // Calendar icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'projectlead':
      return <FaUserTie />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon


    default:
      return null; // Return null if no matching icon is found
  }

};